export const getDomain = (email: string): string | null => email.split('@')[1] || null;
